<template>
  <div class="warp">
    <header-title :title="title">
      <template #title>
        <span @click="goScanPage(isSignalType)">
          {{ title }}
          <expand-outlined
            :style="{ color: '#eddc1d' }"
            v-show="isSignalType"
          />
        </span>
      </template>
      <template #right>
        <andon-badge
          style="margin-right: 10px"
          :region-code="regionCode"
        ></andon-badge>
        <span @click="init">
          <RedoOutlined />
        </span>
      </template>
    </header-title>
    <nav-bar
      :is-signal-type="isSignalType"
      :region-code="regionCode"
      :current="0"
    ></nav-bar>

    <a-spin :spinning="loading">
      <div class="warp-body">
        <a-tabs v-model:activeKey="curObjectId" @change="changeTab" type="card">
          <a-tab-pane
            v-for="item in tabList"
            :key="item.groupId"
            :tab="item.matId"
          >
            <div class="top-h">
              <div class="nav-main">
                <div class="row">
                  <div
                    class="col"
                    v-for="(item, index) in cols"
                    @click="changeTable(item.field, index)"
                    :key="index"
                    :class="{ active: index == curIndex }"
                  >
                    <h4>{{ item.name }}</h4>
                    <p class="number">
                      {{ colsData[item.field] }}
                      <span v-if="item.unit" class="unit">{{ item.unit }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="line-area">
                <div class="title">Stock Level</div>
                <div class="water-line">
                  <div
                    class="line"
                    :style="lineWidth"
                    :class="{ warning: lineWidthValue >= 100 }"
                  >
                    <div class="line-point line-point-up1 point">
                      <span>{{ colsData.availableStock }}</span>
                      <caretDownOutlined></caretDownOutlined>
                    </div>
                  </div>
                  <div
                    class="line-point line-point-down"
                    :style="minStockLeft"
                    style="color: #cc260f"
                  >
                    <caretUpOutlined></caretUpOutlined>
                    <span>{{ colsData.minStock }}</span>
                  </div>

                  <div class="line-point line-point-down line-point-right1">
                    <span>{{ colsData.maxStock }}</span>
                    <caretUpOutlined></caretUpOutlined>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-box" id="aTableRef">
              <a-table
                :columns="columns"
                :row-key="(record) => record.id"
                :data-source="currentDatas"
                :loading="tableLoading"
                :pagination="false"
                :scroll="{ x: isMobile ? 1200 : 'auto', y: tableYHeight }"
                size="small"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.dataIndex === 'subJobId'">
                    <span v-if="record.subJobId1">{{ record.subJobId1 }}</span>
                    <span v-if="record.subJobId1 && record.subJobId2">,</span>
                    <span v-if="record.subJobId2">
                      {{ record.subJobId2 }}
                    </span>
                  </template>
                </template>
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'
  import AndonBadge from '@/components/andon-badge'
  import NavBar from './nav-bar'
  import {
    ExpandOutlined,
    CaretUpOutlined,
    CaretDownOutlined,
    RedoOutlined,
  } from '@ant-design/icons-vue'
  import { Modal } from 'ant-design-vue'
  import { getRegionByGroup } from '@/api/workStation'
  import {
    getObjListByRegionCode,
    getObjDetail,
    getKPIData,
    getMainList,
  } from '@/api/fifo'

  import { mapGetters } from 'vuex'
  import { STAGING_CONSTANT, COLS } from './const'
  import { throttle } from '@/utils'

  export default {
    components: {
      HeaderTitle,
      AndonBadge,
      NavBar,
      ExpandOutlined,
      CaretUpOutlined,
      CaretDownOutlined,
      RedoOutlined,
    },

    data() {
      return {
        regionCode: this.$route.params.regionCode,
        title: this.$route.params.regionCode,
        curObjectId: '',
        tabList: [],
        loading: false,
        tableLoading: false,
        isSignalType: false,
        tableYHeight: 300,
        cols: COLS,
        colsData: {
          alertQtyLow: 0,
          availableStock: 0,
          alertQtyHigh: 0,
          alertQtyMax: 0,
        },

        currentDatas: [],
        columns: STAGING_CONSTANT.initTable,
        curIndex: -1,
        curField: '',
        timer: null,
      }
    },
    created() {
      this.init()
      this.timer = setInterval(() => {
        this.getColsData()
        if (this.curField) {
          this.changeTable(this.curField, this.curIndex)
        } else {
          this.changeTab()
        }
      }, 30000)
    },
    unmounted() {
      clearInterval(this.timer)
    },
    computed: {
      isMobile() {
        return this.device === 'mobile'
      },
      lineWidthValue() {
        return Math.round(
          (this.colsData.availableStock * 100) / this.colsData.maxStock
        ) < 100
          ? Math.round(
              (this.colsData.availableStock * 100) / this.colsData.maxStock
            )
          : 100
      },
      minStockLeft() {
        return {
          left:
            Math.round(
              (this.colsData.minStock * 100) / this.colsData.maxStock
            ) -
            4 +
            '%',
        }
      },

      lineWidth() {
        return {
          width: this.lineWidthValue + '%',
        }
      },
      ...mapGetters({
        device: 'settings/device',
        curNetGroupId: 'user/currentNetGroup',
      }),
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      async init() {
        try {
          this.getTabs()
          this.getColsData()
          this.getSignalType()
          if (this.curField === '') {
            this.changeTab()
          }
        } catch (e) {
          console.log(e)
        }
      },
      async getTabs() {
        try {
          const tabs = await getObjListByRegionCode(this.regionCode)
          if (!tabs.success) {
            Modal.error({
              title: 'Error',
              content: tabs.msg,
            })

            return Promise.reject(tabs.msg)
          }
          this.tabList = tabs.objList
          this.curObjectId = this.tabList[0].groupId
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
      goFifoInit() {
        this.$router.push({
          name: 'fifoInit',
          params: { regionCode: this.regionCode },
        })
      },
      setTableScrollH() {
        let top = 88
        const obj = document.getElementById('aTableRef')
        if (obj) {
          top = obj.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.tableYHeight = wH - (top + 80)
      },
      // 判断是否是 signalType ,用来判断是否要到scan页面
      async getSignalType() {
        try {
          const { body } = await getRegionByGroup({
            netGroupId: this.curNetGroupId,
          })
          if (!body.length) return
          const f = body.find((item) => item.regionCode == this.regionCode)
          this.isSignalType = ['RFID', 'BARCODE'].includes(f.signalType)
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
      goScanPage(isSignalType) {
        if (isSignalType) {
          this.$router.push({
            path: '/scan',
            query: { regionCode: this.regionCode, objectId: this.curObjectId },
          })
        }
      },
      async getColsData() {
        try {
          const d = await getObjDetail(this.regionCode, this.curObjectId)
          this.colsData = d
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },

      async changeTable(field, n) {
        this.columns = field
          ? STAGING_CONSTANT[field]
          : STAGING_CONSTANT.initTable
        this.curField = field
        this.curIndex = n

        try {
          await this.getColsData()
          this.tableLoading = true
          const d = await getKPIData(this.regionCode, this.curObjectId, field)
          this.currentDatas = d.kpiItemList
          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
        }
      },

      async changeTab() {
        this.columns = STAGING_CONSTANT.initTable
        this.curField = ''
        this.curIndex = -1
        this.loading = true
        try {
          await this.getColsData()
          const d = await getMainList(this.regionCode)
          this.currentDatas = d.fifoMainList

          this.loading = false
          return Promise.resolve()
        } catch (e) {
          console.log(e)
          this.currentDatas = []
          this.loading = false
          return Promise.reject(e)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import './fifo.less';

  .warp-body {
    height: calc(100vh - 34px - 44px - 44px);
    overflow: auto;
    padding: 15px;
  }
</style>
